export const staircaseConfig = {
    gameSlug: 'eyes-test-tom',
    category: 'lumiere_emotions',
    variable: 'item_rank',
    startValue: 2,
    minValue: 1,
    maxValue: 5,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 12,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, feedbackEducative: true, label: 'Initiation' };
    }
    if (level <= 20) {
        return { level, feedbackEducative: true, label: 'Décodage' };
    }
    if (level <= 30) {
        return { level, feedbackEducative: false, label: 'Sans béquille' };
    }
    if (level <= 40) {
        return { level, feedbackEducative: false, label: 'Subtilité' };
    }
    return { level, feedbackEducative: false, label: 'Lecture experte' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durées non-staircase. */
export const timing = {
    readingMs: 800,
    feedbackMs: 2200,
    itiMs: 800,
};
export const paradigmMeta = {
    slug: 'eyes-test-tom',
    paradigm: 'Reading the Mind in the Eyes Test (Baron-Cohen et al. 2001)',
    masterMage: 'Sole (lumière-émotions)',
    category: 'lumiere_emotions',
    goal: 'Lecture émotionnelle fine : leadership, soin, parentalité, négociation.',
};
//# sourceMappingURL=params.js.map